"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    attrs: {
      "return-menu": "/farm-management/dashboard",
      menu: _vm.page.children,
      subtitle: _vm.page.meta.title
    }
  }, [_c("template", {
    slot: "context"
  }, [_c("h1", [_vm._v("Faltas justificadas")]), _vm._v(" "), _c("AbsencesTable", {
    attrs: {
      data: _vm.data,
      loading: _vm.isLoading
    },
    on: {
      "toggle-allow": _vm.toggleAllowDevice,
      "create-fixed": _vm.createFixedAccount
    }
  }), _vm._v(" "), _c("b-pagination", {
    staticClass: "mt-4",
    attrs: {
      total: _vm.meta.totalItems,
      current: _vm.meta.currentPage,
      "per-page": _vm.meta.perPage,
      "range-before": "1",
      "range-after": "1",
      size: "is-small",
      order: "is-centered"
    },
    on: {
      "update:current": function updateCurrent($event) {
        return _vm.$set(_vm.meta, "currentPage", $event);
      },
      change: _vm.getAbsences
    }
  })], 1)], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;